import React, { useEffect, useState } from "react"
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import classnames from "classnames"
import { useAppData } from "../../../../Context/appData"
import styles from "./styles.module.scss"
import LoadingSpinner from "../../LoadingSpinner"

function CategoryFilter({ categoryId, categoryName, handleChangeCat, color }) {
  const [isLoading, setIsLoading] = useState(true)
  const { charityCategories } = useAppData()


  const categoryFilterName = categoryId
    ? charityCategories.find(
      ({ CategoryId }) => parseInt(CategoryId) === parseInt(categoryId)
    )?.CategoryName
    : categoryName ? charityCategories.find(
      ({ CategoryName }) => CategoryName.toUpperCase() === categoryName.toUpperCase()
    )?.CategoryName : "Filter By Category"

  if (!charityCategories) {
    return <LoadingSpinner />
  }

  return (
    <div className={styles.wrapper}>
      <UncontrolledDropdown className={styles.filterWrapper}>
        <DropdownToggle
          className={styles.filterTrigger}
          nav
          caret
          style={{ color }}>
          {categoryFilterName && categoryFilterName.length > 22
            ? categoryFilterName.slice(0, 22) + "..."
            : categoryFilterName}
        </DropdownToggle>
        <DropdownMenu className={styles.filterList}>
          <DropdownItem
            className={classnames(styles.filterItem, styles.clear)}
            onClick={() => {
              handleChangeCat(null)
            }}>
            Clear
          </DropdownItem>
          {!!charityCategories &&
            charityCategories
              .map(({ CategoryId, CategoryName }) => (
                <DropdownItem
                  key={CategoryId}
                  className={styles.filterItem}
                  onClick={() =>
                    handleChangeCat(CategoryId)
                  }>
                  {CategoryName}
                </DropdownItem>
              ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  )
}

export default CategoryFilter
